import loadScript from 'load-script'
import config from '../config';

let fsClient;

const loadScripts = () => {
    return new Promise((resolve, reject) => {
        if (typeof window !== "undefined") {
            loadScript('https://static.filestackapi.com/filestack-js/1.5.1/filestack.min.js', function (err, script) {
                if (err) {
                    console.error(err);
                    reject();
                    return
                }
                fsClient = filestack.init(config('FILESTACK_KEY'));
                resolve();
            })
        } else {
            reject();
            return
        }

    })

}

const getImageUrl = (image, width, height) => {
    const handle = image.handle
        ? image.handle
        : image;
    let resizeParams = `width:${width}`;
    resizeParams = (height)
        ? `${resizeParams},height:${height}`
        : resizeParams;
    resizeParams = `${resizeParams},fit:crop`;
    return `https://process.filestackapi.com/resize=${resizeParams}/${handle}`
}

export {loadScripts, fsClient, getImageUrl}



// WEBPACK FOOTER //
// ./services/ImageService.js